"use strict";

APP.scenes.PreloaderScene = function () {

    // Invoke (needed)
    EHDI.aka.Container.call(this);

    APP.managers.json = EHDI.JSONManager(null, EHDI.Assets.fetch("assets/preloader_strings/strings.json"));

    // Properties

    // ** Parent (This reference)
    var _parent = this;

    // ** General Values
    var _isLoaded = false;

    // ** Graphics
    var _animRobot, _dbFactory, _textureImage, _textureAtlas, _skeleton, _armature,
        _sprBar_bg, _sprBar_border, _sprBar_fill, _sprBg, _sprBorder,
        _twnTap, _txtExoBold, _txtExoMedium, _txtLoading, _txtProxima, _txtTap;

    var _anyKeyAct;
    // Private Methods

    // ** General Methods
    var _changeScene = function () {

        // Change to next scene
        APP.managers.scene.changeScene(new EHDI.scene.titleScene(), { alpha: new EHDI.scene.TransitionParameter(0, 1), duration: 1 });
    };

    // **  Handlers
    var _handler_frameUpdate = function (p_delta) {

        if (_sprBar_fill) _sprBar_fill.scale.x = APP.managers.load.getProgress() / 100;

        // dragonBones.WorldClock.clock.advanceTime( p_delta * 0.001 );
    };

    var _handler_loadComplete = function () {

        if (_isLoaded) return;

        // Set isLoaded to true
        _isLoaded = true;

        // Set bar fill
        if (_sprBar_fill) _sprBar_fill.scale.x = APP.managers.load.getProgress() / 100;

        // Do according to device
        if (EHDI.BrowserInfo.isMobileDevice) {

            // Hide bar fill and bg
            if (_sprBar_fill) _sprBar_fill.visible = false;
            if (_sprBar_bg) _sprBar_bg.visible = false;

            // Add tap text
            if (!_txtTap) {

                _txtTap = new EHDI.displays.TextSprite(APP.managers.json.getLocale("STR_TAP_CONT"));
                _txtTap.anchor.set(0.5, 0.5);
                _txtTap.position.set(APP.config.stageWidth * 0.5, APP.config.stageHeight * 0.65);
                _txtTap.alpha = 0;
                _parent.addChild(_txtTap);

                if (!_twnTap) {

                    _twnTap = new TimelineMax();
                    _twnTap.to(_txtLoading, 0.25, { alpha: 0 }, 0);
                    _twnTap.to(this, 0.25, { alpha: 0 }, 0);
                    _twnTap.to(_txtTap, 0.25, { alpha: 1 }, 0);
                    _twnTap.add(function () {
                        if (_sprBg) _sprBg.interactive = true;
                        _twnTap.kill();
                        _twnTap = new TimelineMax({ repeat: -1, repeatDelay: 1, delay: 1 });
                        _twnTap.to(_txtTap, 1, { alpha: 0 });
                        _twnTap.to(_txtTap, 0.5, { alpha: 1 }, "+=0.2");
                    });
                }
            }

            if (_sprBg) {

                _sprBg.touchstart = function () {

                    // Set interactive to false
                    _sprBg.interactive = false;

                    // Play button sound
                    APP.managers.sound.playSFX("button_sfx");

                    // Change scene
                    _changeScene();
                };
            }
        }
        else if (!EHDI.BrowserInfo.isMobileDevice) {

            // Hide bar fill and bg
            if (_sprBar_fill) _sprBar_fill.visible = false;
            if (_sprBar_bg) _sprBar_bg.visible = false;
            // Add tap text
            if (!_txtTap) {

                _txtTap = new EHDI.displays.TextSprite(APP.managers.json.getLocale("STR_ANYKEY_CONT"));
                _txtTap.anchor.set(0.5, 0.5);
                _txtTap.position.set(APP.config.stageWidth * 0.5, APP.config.stageHeight * 0.65);
                _txtTap.alpha = 0;
                _parent.addChild(_txtTap);

                if (!_twnTap) {

                    _twnTap = new TimelineMax();
                    _twnTap.to(_txtLoading, 0.25, { alpha: 0 }, 0);
                    _twnTap.to(this, 0.25, { alpha: 0 }, 0);
                    _twnTap.to(_txtTap, 0.25, { alpha: 1 }, 0);
                    _twnTap.add(function () {
                        if (_sprBg) _sprBg.interactive = true;
                        _twnTap.kill();
                        _twnTap = new TimelineMax({ repeat: -1, repeatDelay: 1, delay: 1 });
                        _twnTap.to(_txtTap, 1, { alpha: 0 });
                        _twnTap.to(_txtTap, 0.5, { alpha: 1 }, "+=0.2");
                    });
                }
            }
            if (_sprBg) {
                _parent.interactive = true;

                _anyKeyAct = function () {
                    // Set interactive to false
                    _sprBg.interactive = false;

                    // Play button sound
                    APP.managers.sound.playSFX("button_sfx");

                    // Change scene
                    window.removeEventListener('keydown', _anyKeyAct);
                    _parent.off("pointerdown", _anyKeyAct);
                    _changeScene();
                }

                window.addEventListener('keydown', _anyKeyAct);
                _parent.on("pointerdown", _anyKeyAct);
            }
        }
        else {
            // Timeout before next scene
            setTimeout(function () {
                // Change scene
                _changeScene();
            }, 500);
        }
    };


    // ** Initialization Methods

    var _initGraphics = function () {

        // Initialize fonts needed for texts
        if (!_txtExoBold) {
            _txtExoBold = new EHDI.aka.PixiText("ExoBold", { fontFamily: "exo-bold", fill: 0xFFFFFF, fontSize: 16 });
            _parent.addChild(_txtExoBold);
        }

        if (!_txtExoMedium) {
            _txtExoMedium = new EHDI.aka.PixiText("ExoMedium", { fontFamily: "exo-medium", fill: 0xFFFFFF, fontSize: 16 });
            _parent.addChild(_txtExoMedium);
        }

        if (!_txtProxima) {
            _txtProxima = new EHDI.aka.PixiText("Proxima", { fontFamily: "proximanova-black", fill: 0xFFFFFF, fontSize: 16 });
            _parent.addChild(_txtProxima);
        }

        // Initialize bg and border
        if (!_sprBg) {
            _sprBg = new EHDI.aka.TilingSprite(EHDI.Assets.images["gfx_bg"],
                APP.config.stageWidth,
                APP.config.stageHeight);

            _parent.addChild(_sprBg);
        }

        if (!_sprBorder) {
            _sprBorder = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_loading"]);
            _sprBorder.anchor.set(0.5, 0.5);
            _sprBorder.position.set(APP.config.stageWidth * 0.5,
                APP.config.stageHeight * 0.5);
            _parent.addChild(_sprBorder);
        }

        // Initialize loading bar components
        if (!_sprBar_border) {
            _sprBar_border = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_loading_bar_con"]);
            _sprBar_border.anchor.set(0.5, 0.5);
            _sprBar_border.position.set(APP.config.stageWidth * 0.5,
                APP.config.stageHeight * 0.64);
            _parent.addChild(_sprBar_border);
        }

        if (!_txtLoading) {
            var loadingStyle = APP.managers.json.getLocale("STR_LOADING");
            _txtLoading = new EHDI.displays.TextSprite(loadingStyle);
            _txtLoading.style = loadingStyle.STYLE;
            _txtLoading.position.set(APP.config.stageWidth * 0.316,
                APP.config.stageHeight * 0.595);
            _parent.addChild(_txtLoading);
        }

        if (!_sprBar_bg) {
            _sprBar_bg = new EHDI.displays.FillRectangle(0x000000, 0, 0, 380, 27);
            _sprBar_bg.anchor.set(0.5, 0.5);
            _sprBar_bg.position.set(APP.config.stageWidth * 0.5,
                APP.config.stageHeight * 0.65);
            _parent.addChild(_sprBar_bg);
        }

        if (!_sprBar_fill) {
            _sprBar_fill = new EHDI.displays.FillRectangle(0x1999F1, 0, 0, 380, 27);
            _sprBar_fill.position.set(-(_sprBar_bg.width * 0.5),
                -(_sprBar_bg.height * 0.5));
            _sprBar_bg.addChild(_sprBar_fill);
        }

        if (!_animRobot) {

            // _dbFactory = new dragonBones.PixiFactory();
            // _textureImage = EHDI.Assets.images[ "assets/preloader_ui/GizmoLoading_tex.png" ].baseTexture.source;

            // _textureAtlas = EHDI.Assets.fetch( "GizmoLoading_tex" );
            // _dbFactory.addTextureAtlas( new dragonBones.TextureAtlas( _textureImage, _textureAtlas ) );

            // _skeleton = EHDI.Assets.fetch( "GizmoLoading_ske" );

            // _dbFactory.addDragonBonesData( dragonBones.DataParser.parseDragonBonesData( _skeleton ) );

            // _armature = _dbFactory.buildArmature( _skeleton.armature[ 0 ].name );
            // dragonBones.WorldClock.clock.add( _armature );
            // _armature.animation.gotoAndPlay( _armature.animation.animationList[0], -1, -1, 0 );
            // _armature.animation.play();

            // _animRobot = _armature.getDisplay();
            // _animRobot.position.set( APP.config.stageWidth * 0.5, APP.config.stageHeight * 0.55 );
            // _parent.addChild( _animRobot );

            _dbFactory = new dragonBones.PixiFactory();

            EHDI.DBoneFactory.start("GizmoLoading_tex", "GizmoLoading_tex", "GizmoLoading_ske");
            _armature = EHDI.DBoneFactory.createArmature("Gizmo");
            dragonBones.WorldClock.clock.add(_armature);
            _armature.animation.gotoAndPlay(_armature.animation.animationList[0], -1, -1, 0);
            _armature.animation.play();
            var animationSprite = _armature.getDisplay();;
            animationSprite.position.set(APP.managers.scene.getStageWidth() * 0.5, APP.managers.scene.getStageHeight() * 0.55);

            _parent.addChild(animationSprite);



        }

    };

    var _initListeners = function () {

        // Add frame listeners
        APP.managers.update.addFrameListener(_handler_frameUpdate);
    };

    // ** Kill Methods

    var _killGraphics = function () {

        if (_dbFactory) _dbFactory.dispose();
        _dbFactory = null;

        _textureImage = null;
        _textureAtlas = null;
        _skeleton = null;

        if (_armature) {
            dragonBones.WorldClock.clock.remove(_armature);
            _armature.dispose();
        }
        _armature = null;

        // Destroy children
        _parent.destroy({ children: true });
    };

    var _killListeners = function () {

        // Remove frame listeners
        window.removeEventListener('keydown', _anyKeyAct);
        _parent.off("pointerdown", _anyKeyAct);
        APP.managers.update.removeFrameListener(_handler_frameUpdate);
    };

    // ** General Methods

    var _startLoad = function () {

        // Initialize load manager            
        APP.managers.load.queueAssets(AssetDirectory.load);
        APP.managers.load.start(_handler_loadComplete);


    };

    this.screenWillAppear = function () {

        // Initialize graphics
        _initGraphics();

        // Initialize listeners
        _initListeners();
    };

    this.screenDidAppear = function () {
        // Start load
        _startLoad();
    };

    this.screenWillDisappear = function () {


    };

    this.screenDidDisappear = function () {

        // Kill listeners
        _killListeners();

        // Kill graphics
        _killGraphics();
    };

    this.destroy = function () {

        APP.scenes.PreloaderScene.prototype.destroy.apply(this, arguments);
    };



    // ** Handlers



};
APP.scenes.PreloaderScene.prototype = Object.create(EHDI.aka.Container.prototype);
APP.scenes.PreloaderScene.prototype.constructor = APP.scenes.PreloaderScene;